!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? r(exports, require("@material-ui/icons"), require("@material-ui/pickers"), require("formik"), require("luxon"), require("react")) : "function" == typeof define && define.amd ? define(["exports", "@material-ui/icons", "@material-ui/pickers", "formik", "luxon", "react"], r) : r((e = e || self)["time-picker"] = {}, e.icons, e.pickers, e.formik, e.luxon, e.React);
}(this, function (e, r, t, i, n, l) {
  "use strict";

  l = l && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
  e.TimePicker = function (e) {
    var a = e.id,
        o = e.name,
        u = e.inputVariant,
        s = e.mask,
        c = e.required,
        m = e.fullWidth,
        d = e.slow,
        f = e.customError,
        p = i.useFormikContext();
    return l.createElement(i.Field, {
      name: o,
      slow: d
    }, function (d) {
      var h = d.form,
          k = h.errors,
          b = h.touched,
          y = h.setFieldValue,
          v = h.setFieldTouched,
          x = i.getIn(k, o),
          g = i.getIn(b, o) && !!x && !f;
      return l.createElement(t.KeyboardTimePicker, {
        id: a,
        autoOk: !0,
        variant: "inline",
        error: g,
        helperText: g ? x : null,
        inputVariant: u || "filled",
        required: c,
        InputLabelProps: {
          shrink: !0
        },
        placeholder: s || "--:-- am/pm",
        mask: s || "--:-- -m",
        maskChar: "-",
        keyboardIcon: l.createElement(r.AccessTime, {
          fontSize: "small",
          color: "disabled"
        }),
        InputProps: {
          style: {
            paddingRight: 4
          }
        },
        label: e.label,
        fullWidth: m,
        onChange: function onChange(e, r) {
          var t = e && e.isValid ? e : null,
              i = !t && r ? n.DateTime.fromFormat(r, "hh:mm a") : null,
              l = null != t ? t : i;
          return y(o, l ? l.set({
            second: 0,
            millisecond: 0
          }).toJSDate() : "");
        },
        value: i.getIn(p.values, o) ? n.DateTime.fromJSDate(i.getIn(p.values, o)) : null,
        labelFunc: function labelFunc(e) {
          return e && e.isValid ? e.toFormat("hh:mm a").toLowerCase() : "";
        },
        onBlur: function onBlur() {
          return v(o, !0);
        }
      });
    });
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});